import { isDesktopRuntime } from './desktopDetection';

/**
 * Hands an external address to the desktop shell's own opener (I-1068, ADR-160), so it reaches the
 * system browser or mail client instead of the app's webview.
 *
 * The native navigation guard (`desktop/src-tauri/src/link_navigation.rs`) is what actually
 * enforces this — it refuses any in-webview navigation that leaves the app's own origin and hands
 * an http, https, mailto or tel address to the system instead, whatever reaches it. This function
 * lets the desktop runtime's own click handling hand the address over
 * directly, so the system opens it without the window ever attempting — and visibly failing — the
 * navigation first.
 *
 * A no-op outside the desktop runtime: an ordinary browser tab already does the right thing with a
 * plain anchor, and there is no native bridge to call.
 */
export async function openExternal(href: string): Promise<void> {
  if (!isDesktopRuntime()) return;
  const { invoke } = await import('@tauri-apps/api/core');
  await invoke('open_external_url', { url: href });
}
